import axios from 'axios'

let baseURL = 'https://r2test.mjb6.cn:8443/api'

if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://r2.mjb6.cn:8443/api'
}

// mock server
// baseURL = 'http://139.199.201.147:4000/api'

const api = axios.create({
  baseURL,
  params: {
    utm_app_version: '1.0',
    versionCode: '1.0.0',
    clientType: 3, // ANDROID(1, "ANDROID"), IOS(2, "IOS"), WEB(3, "WEB");
  },
  transformResponse: axios.defaults.transformResponse.concat((response) => {
    if (response.success) {
      return response.data
    }

    // 服务端错误 默认处理为error
    const error = new Error(response.errMsg)
    error.errCode = response.errCode
    error.errMsg = response.errMsg
    throw error
  }),
})

export default api



// WEBPACK FOOTER //
// ./src/api/index.js